/* RecovryCo theme — light interactivity (no framework) */
(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  /* Mobile nav toggle ------------------------------------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* FAQ accordion ----------------------------------------- */
  function initFaq() {
    document.querySelectorAll('[data-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq__item');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  /* Product gallery thumbnails ---------------------------- */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (src) {
          main.src = src;
          main.alt = alt;
        }
      });
    });
  }

  /* Quantity stepper -------------------------------------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
        });
      });
    });
  }

  /* Free-shipping progress in cart ------------------------ */
  function initShippingBar() {
    var bar = document.querySelector('[data-ship-bar]');
    if (!bar || !window.RecovryCo) return;
    var threshold = (window.RecovryCo.freeShippingThreshold || 60) * 100;
    var subtotal = parseInt(bar.getAttribute('data-subtotal'), 10) || 0;
    var msg = bar.querySelector('[data-ship-msg]');
    var fill = bar.querySelector('[data-ship-fill]');
    if (subtotal >= threshold) {
      if (msg) msg.innerHTML = "You've unlocked <strong>free shipping</strong> 🎉";
    } else if (msg) {
      msg.innerHTML = "You're <strong>" + formatMoney(threshold - subtotal) +
        "</strong> away from free shipping";
    }
    if (fill) fill.style.width = Math.min(100, (subtotal / threshold) * 100) + '%';
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initFaq();
    initGallery();
    initQty();
    initShippingBar();
  });
})();
